/* eslint-disable prettier/prettier */
import './EasySoftwareTabs.scss'

import React, { FunctionComponent, useRef, useState } from 'react'

import EasySoftwareEditorContainer from '../EasySoftwareEditorContainer/EasySoftwareEditorContainer'
import { EasyDynamicEightType } from '../EasyDynamicEight/EasyDynamicEight'
import EasySoftwareTabsItem, { EasySoftwareTabsItemType } from './EasySoftwareTabsItem'

export interface EasySoftwareTabsType {
  pageContentItemId: string,
  editorPath: string,
  tabsContentPositionDesktop: boolean,
  tabsBackground: string,
  easyDynamicEight?: EasyDynamicEightType,
  bag: {
    contentItems: EasySoftwareTabsItemType[],
  }
}

const EasySoftwareTabs: FunctionComponent<EasySoftwareTabsType> = (
  props
) => {

  const [tabsOpen, setTabsOpen] = useState(0)
  const tabsHeadingsRef = useRef<HTMLDivElement>(null)
  const tabsClasses = [`Tabs`]

  if (props.tabsBackground) {
    tabsClasses.push(`Tabs--${props.tabsBackground}`)
  }

  return (
    <div className={tabsClasses.join(` `)}>
      <div className='Tabs-wrapper'>
        <div className='Tabs-headings' ref={tabsHeadingsRef}>
          {props.bag &&
            props.bag.contentItems &&
            props.bag.contentItems.map((item, index) => (
              <div className={`Tabs-heading ${index === tabsOpen ? `is-active` : ``}`} onClick={() => setTabsOpen(index)} key={index}>
                <EasySoftwareEditorContainer 
                  pageContentItemId={props.pageContentItemId} 
                  type="input"
                  content={item.displayText} 
                  wysiwygId={item.contentItemId} 
                  editorPath={props.editorPath + `,cid-${item.contentItemId},displayText`} 
                />
              </div>
            ))}
        </div>
        <button
          className='Tabs-scrollButton'
          type='button'
          aria-label='Scroll tabs'
          onClick={() => tabsHeadingsRef.current?.scrollBy({ left: 120, behavior: `smooth` })}
        />
      </div>
      <div className={`Tabs-items ` + (props.tabsContentPositionDesktop ? `Tabs--reverse` : ``)}>
        {props.bag &&
          props.bag.contentItems &&
          props.bag.contentItems.map((item, index) => (
            <EasySoftwareTabsItem pageContentItemId={props.pageContentItemId} key={item?.contentItemId} data={item} index={index} isOpen={index === tabsOpen ? true : false} setTabsOpen={setTabsOpen} editorPath={props.editorPath + `,cid-${item.contentItemId},easySoftwareTabsItem,tabsItemContent,html`} easyDynamicEight={props.easyDynamicEight} />
          ))}
      </div>
    </div>
  )
}

export default EasySoftwareTabs
